/**
 * Lägenhetsförteckning — a clean, attachable bilaga holding one horizontal
 * apartment list. No parties, no own signing, no form number.
 */
import { em, p, section, table, val } from '@hyranai/regta-document-ir';
import { slotText } from '../common/slots.js';
import { rows } from '../lib.js';
/** Legacy widths were 6/14/5/5/7 rem; carried as relative weights. */
export const APARTMENT_COLUMNS = [
    { key: 'lagenhetsnummer', label: 'Lägenhetsnr', width: 16 },
    { key: 'adress', label: 'Adress', width: 38 },
    { key: 'antal_rum', label: 'Antal rum', width: 14 },
    { key: 'yta_kvm', label: 'Yta (m²)', width: 14 },
    { key: 'hyra_manad', label: 'Hyra (kr/mån)', width: 18 },
];
export const lagenheter = {
    blockKey: 'lagenhetsforteckning.lagenheter',
    version: 'v1',
    plane: 'shared',
    status: 'published',
    language: 'sv-SE',
    title: 'Lägenhetsförteckning',
    summary: 'A numbered section holding the horizontal apartment list: one row per apartment.',
    slots: [
        {
            key: 'units',
            label: 'Lägenheter',
            type: 'table',
            repeats: true,
            help: 'En rad per lägenhet. Lägg till, ta bort och sortera raderna fritt.',
            columns: APARTMENT_COLUMNS.map((c) => ({ key: c.key, label: c.label, type: 'text' })),
        },
    ],
    compile: (input) => {
        const columns = APARTMENT_COLUMNS.map((c) => ({
            key: c.key,
            header: [{ type: 'text', text: c.label }],
            align: 'left',
            width: c.width,
        }));
        const units = rows(input.units);
        const body = units.length === 0
            ? [
                {
                    cells: [
                        {
                            content: [p([em('(Inga lägenheter ifyllda ännu)')], { align: 'center' })],
                            colSpan: columns.length,
                        },
                    ],
                },
            ]
            : units.map((row, index) => ({
                cells: APARTMENT_COLUMNS.map((c) => ({
                    content: [p([val(slotText(row[c.key]), { sourceKey: `units.${index}.${c.key}`, blankWidth: 'short' })])],
                })),
            }));
        return [
            section('lagenheter', 'Lägenhetsförteckning', [table(columns, body, { variant: 'data', repeatTableHeader: true })]),
        ];
    },
};
export const LAGENHETSFORTECKNING_BLOCKS = [lagenheter];
//# sourceMappingURL=blocks.js.map